import { Snackbar } from "@mui/material";
import React from "react";

const ToastMessage = ({
  open,
  message = "",
  closeTiming,
  handleClose,
  backgroundColor = "green",
  position = { vertical: "top", horizontal: "center" },
}) => {
  return (
    <>
      <Snackbar
        ContentProps={{
          sx: {
            background: backgroundColor,
          },
        }}
        open={open}
        anchorOrigin={position}
        autoHideDuration={closeTiming}
        onClose={handleClose}
        message={message}
      />
    </>
  );
};

export default ToastMessage;
